angular.module('bmsApp.sm.job', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.sm.job', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/sm/job/templates/JobMain.html',
							controller: 'SMJobMainCtrl'
						}
					}
				})

				.state('main.sm.job.index', {
					url: '^/sm/jobs',
					views: {
						'content@main.sm.job': {
							templateUrl: 'ng/sm/job/templates/JobIndex.html',
							controller: 'SMJobIndexCtrl'
						},
						'side@main.sm.job': {
							templateUrl: "ng/sm/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Jobs'}
				})

				.state('main.sm.job.index.view', {
					url: '^/sm/job/view/{jobId}',
					views: {
						'content@main.sm.job': {
							templateUrl: 'ng/sm/job/templates/JobView.html',
							controller: 'SMJobViewCtrl'
						},
						'side@main.sm.job': {
							templateUrl: "ng/sm/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label:  "{{ job.name }}" }
				})

				.state('main.sm.job.index.view.edit', {
					url: '^/sm/job/edit/{jobId}',
					views: {
						'content@main.sm.job': {
							templateUrl: 'ng/sm/job/templates/JobSave.html',
							controller: 'SMJobSaveCtrl'
						},
						'side@main.sm.job': {
							templateUrl: "ng/sm/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label:  'Edit' }
				})

				.state('main.sm.job.closeJobList', {
					url: '^/sm/jobs/close-list',
					views: {
						'content@main.sm.job': {
							templateUrl: 'ng/sm/job/templates/JobCloseList.html',
							controller: 'SMJobCloseListCtrl'
						},
						'side@main.sm.job': {
							templateUrl: "ng/sm/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Close Jobs List'}
				})

				.state('main.sm.job.closeJobList.close', {
					url: '^/sm/job/close/{jobId}',
					views: {
						'content@main.sm.job': {
							templateUrl: 'ng/sm/job/templates/JobClose.html',
							controller: 'SMJobCloseCtrl'
						},
						'side@main.sm.job': {
							templateUrl: "ng/sm/job/templates/JobCloseSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Close Job'}
				})

			;

		}]);
